import MatchHeight from 'matchheight'
import cssVars from 'css-vars-ponyfill'
import ScrollOut from 'scroll-out'

export default {
  init() {
    // JavaScript to be fired on all pages

    $(window).on('load', () => {
      MatchHeight.init()

      if (document.getElementById('bubbles-back')) {
        this.createBubblesCurve()
      }

      // TODO: remove once all react components have been processed
      // see https://app.clickup.com/t/2chjd6p
      // setTimeout(function () {
      ScrollOut({
        once: true,
        onShown(el) {
          el.classList.add('animated')
        },
      })
      // }, 1000)

      const isMacOS = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
      if (isMacOS) {
        $('body').addClass('mac-os')
        var isChromium = window.chrome,
          vendorName = window.navigator.vendor,
          isOpera = window.navigator.userAgent.indexOf('OPR') > -1
        if (
          isChromium !== null &&
          isChromium !== undefined &&
          vendorName === 'Google Inc.' &&
          isOpera == false
        ) {
          // is Google chrome
          $('body').addClass('chrome')
        }
      } else {
        $('body').addClass('win-os')
      }

      $('.search-icon, .primary-search-icon, .search-modal__close').on(
        'click',
        () => {
          $('.search-modal').toggleClass('active')
        }
      )

      let $header = $('.header')
      $('a[href^="#"]').on('click', function (e) {
        e.preventDefault()
        let $this = $(this).attr('href')
        $($this).find('.glossar-accordion').trigger('click')
        let scrollTop =
          $($(this).attr('href')).offset().top - $header.outerHeight()

        $('html, body').animate({ scrollTop })
      })

      //Add Hotspot To Accordion Links
      const links = $('.accordion-item__desc').find('span.hotspot')
      if (links.length) {
        links.each(function () {
          const link_text = $(this).html()
          $(this).closest('a').addClass('hotspot').html(link_text)
          $(this).remove()
        })
      }

      this.addHotspot()
      this.dotsCarousel()
      this.hotspotMobile()
    })

    $(window).on('resize', () => {
      this.setCssVars()
      this.hotspotMobile()
    })

    $(window).scroll(() => {
      this.navFixed()
    })

    this.anchorScroll()
    this.toggleDropdown('.share-btn-logo', '.social-btns', '.share-btn')
    this.toggleDropdown(
      '.nav-top .langswitcher-title',
      '.nav-top .langswitcher-wrapper .wpml-ls',
      '.nav-top .langswitcher-wrapper'
    )
    this.toggleDropdown(
      '.main-header-nav .langswitcher-icon',
      '.main-header-nav .langswitcher-wrapper .wpml-ls',
      '.main-header-nav .langswitcher-wrapper'
    )
    this.toggleNav()
    this.scrollToTop()
    this.scrollToAnchor()
    this.addAnimation()
    this.accordion('.glossar-accordion')
    this.accordion('.accordion-item__title')
    this.setCssVars()
    this.addSpacingTextBlock()
    // this.searchLoadMore()
    this.searchMore()
    this.textParallax()
    this.shareLink()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  navFixed() {
    let scroll = $(window).scrollTop()
    if (scroll > 130) {
      $('body').addClass('fixed')
    } else {
      $('body').removeClass('fixed')
    }
  },

  toggleDropdown(titleSelector, contentSelector, wrapperSelector) {
    let title = document.querySelector(titleSelector)
    let content = document.querySelector(contentSelector)
    let wrapper = document.querySelector(wrapperSelector)
    if (title && content) {
      title.addEventListener('click', function () {
        if (content.classList.contains('active')) {
          content.classList.remove('active')
        } else {
          content.classList.add('active')
        }
      })

      document.addEventListener('click', function (event) {
        let wrapperClick = wrapper.contains(event.target)
        if (!wrapperClick) {
          if (content.classList.contains('active')) {
            content.classList.remove('active')
          }
        }
      })
    }
  },

  dotsCarousel() {
    let slider = $(document).find('.dhsv-image-carousel-block')
    if (slider.length > 0) {
      slider.each(function () {
        var img = $(this).find('.slider .slide-current img').outerHeight()
        $(this)
          .find('.slider-control-bottomcenter')
          .css('top', img + 'px')
        $(this)
          .find('.slider-control-centerright')
          .css('top', img / 2 + 'px')
        $(this)
          .find('.slider-control-centerleft')
          .css('top', img / 2 + 'px')
      })
    }
  },

  toggleNav() {
    let navButton = $('#nav-button')
    let navMain = $('.nav-primary .nav')

    navButton.click(function () {
      $(this).toggleClass('open')
      $(navMain).toggleClass('open')
    })
  },

  scrollToTop() {
    let scrollButton = document.getElementById('toTopBtn')
    // window.onscroll = function () {
    //   scrollFunction()
    // }
    // function scrollFunction() {
    //   if (
    //     document.body.scrollTop > 0 ||
    //     document.documentElement.scrollTop > 0
    //   ) {
    //     scrollButton.style.display = 'block'
    //   } else {
    //     scrollButton.style.display = 'none'
    //   }
    // }
    if (scrollButton != null || scrollButton != undefined) {
      scrollButton.onclick = function () {
        $('html, body').animate({ scrollTop: 0 }, 'fast')
      }
    }
  },

  scrollToAnchor() {
    let $header = $('.header')
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault()
      let scrollTop =
        $($(this).attr('href')).position().top - $header.outerHeight()

      $('html, body').animate({ scrollTop })
    })
  },

  createBubblesCurve() {
    const canvas = document.getElementById('bubbles-back')
    const ctx = canvas.getContext('2d')

    let container,
      bubbles = []

    setupCanvas()
    // addHotspot()

    let params = {
      number: Math.floor(container.w / 120),
      maxSize: 24,
      riseSpeed: 0.001,
      curviness: 3,
    }

    for (let i = 0; i < params.number; i++) {
      bubbles.push(new Bubble(i))
    }
    updateBubbles()

    window.addEventListener('resize', () => {
      const oldNumberOfBubbles = params.number
      params.number = Math.floor(container.w / 120)
      setupCanvas()
      for (let i = oldNumberOfBubbles; i < params.number; i++) {
        bubbles.push(new Bubble(i))
      }
    })

    // canvas constructor
    function Bubble(i) {
      this.rand = Math.random() * Math.PI * 2
      this.progress = Math.random()
      this.deltaX = (1 / params.number) * container.w * 0.5 - params.maxSize
      this.initX = (i / params.number) * container.w
      this.size = params.maxSize * (0.3 + Math.random() * 0.7)
      this.position = { x: container.w * 0.5, y: 0 }
      this.update = function () {
        this.progress -= params.riseSpeed * (1 + 0.1 * this.rand)
        this.position.x =
          this.initX +
          Math.sin(this.progress * params.curviness + this.rand) * this.deltaX
        this.position.y = this.progress * container.h
      }
    }

    function updateBubbles() {
      ctx.clearRect(0, 0, container.w, container.h)
      ctx.strokeStyle = '#991D85'
      bubbles.forEach(c => {
        c.update()
        ctx.beginPath()
        ctx.arc(c.position.x, c.position.y, c.size, 0, 2 * Math.PI)
        ctx.stroke()
      })
      bubbles.forEach(c => {
        if (c.progress < -0.1) c.progress = 1.1
      })
      window.requestAnimationFrame(updateBubbles)
    }

    function setupCanvas() {
      container = {
        w: canvas.clientWidth,
        h: canvas.clientHeight,
      }
      canvas.width = container.w
      canvas.height = container.h
    }
  },
  addAnimation() {
    const wpImages = document.querySelectorAll('article .wp-block-image')
    wpImages.forEach(figure => {
      figure.setAttribute('data-scroll', '')
    })
    // ScrollOut({
    //   once: true,
    //   onShown(el) {
    //     el.classList.add('animated')
    //   },
    // })
    // window.addEventListener('load', () => {
    //   window.ScrollOut({
    //     once: true,
    //   })
    // })
  },
  setCssVars() {
    cssVars({
      variables: {
        '--footerHeight': $('.footer__container').outerHeight() + 'px',
      },
    })
  },
  accordion(accordion_class) {
    window.addEventListener('load', () => {
      const accordionBtns = document.querySelectorAll(accordion_class)
      accordionBtns.forEach(accordion => {
        accordion.onclick = function () {
          this.classList.toggle('is-open')
          let content = this.nextElementSibling
          if (content.style.maxHeight) {
            content.style.maxHeight = null
            content.style.paddingBottom = 0
          } else {
            content.style.maxHeight = content.scrollHeight + 15 + 'px'
            content.style.paddingBottom = '15px'
          }
        }
      })
      if (window.location.hash.length > 0) {
        $(window.location.hash).find('.glossar-accordion').addClass('is-open')
        let content = $(window.location.hash).find('.glossar-accordion')[0]
          .nextElementSibling
        content.style.maxHeight = content.scrollHeight + 15 + 'px'
        content.style.paddingBottom = '15px'
      }
    })
  },
  addSpacingTextBlock() {
    let innerTxt = $(document).find('.first-colored-letter')
    innerTxt.closest('.wp-block-columns').css('margin-bottom', '0.87em')
  },
  addHotspot() {
    let hotspotLinks = document.querySelectorAll(
      '.single .entry-content a.hotspot, .dhsv-accordion a.hotspot'
    )

    hotspotLinks.forEach(hotspotLink => {
      hotspotLink.addEventListener(
        'mouseover',
        function () {
          $(this).addClass('show')
        },
        { once: true }
      )
      hotspotLink.addEventListener('mouseout', function () {
        $(this).removeClass('show')
      })

      hotspotLink.setAttribute('target', '_blank')

      if (
        hotspotLink.closest('p, span, h1, h2, h3, h4, h5, h6, div') != null ||
        hotspotLink.closest('p, span, h1, h2, h3, h4, h5, h6, div') != undefined
      ) {
        hotspotLink
          .closest('p, span, h1, h2, h3, h4, h5, h6, div')
          .classList.add('hotspot-container')
      }

      const myURL = hotspotLink.href
      const url = new URL(myURL)
      const siteLang = $('html').attr('lang') === 'de-DE' ? '' : '/en'
      let postSlug = url.pathname.split('/').filter(Boolean)
      const newUrl =
        url.origin +
        siteLang +
        '/' +
        postSlug[postSlug.length - 2] +
        '/#' +
        postSlug[postSlug.length - 1]
      postSlug = postSlug[postSlug.length - 1]
      hotspotLink.setAttribute('href', newUrl)

      /* global theme_global_data */
      $.ajax({
        url: theme_global_data.ajax_url,
        type: 'GET',
        data: {
          action: 'get_post_data',
          post_slug: postSlug,
        },
        success: function (data) {
          const newDiv = document.createElement('div')
          const currentLang = document
            .querySelector('html')
            .getAttribute('lang')
          newDiv.classList.add('hotspot-content')
          newDiv.insertAdjacentHTML('beforeend', data)
          hotspotLink.append(newDiv)
          let hotspotLinkOffset = hotspotLink.getBoundingClientRect()
          hotspotLink.style.setProperty(
            '--hotspot-triangle-position',
            hotspotLinkOffset.left - 15
          )
          let hotspotLinksMore = newDiv.querySelectorAll('a')
          hotspotLinksMore.forEach((hotspotLinkMore, index, colection) => {
            if (colection.length - 1 === index) {
              hotspotLinkMore.setAttribute('href', newUrl)
              if (currentLang === 'de-DE') {
                hotspotLinkMore.innerHTML = 'mehr im Glossar'
              } else if (currentLang === 'en-US') {
                hotspotLinkMore.innerHTML = 'more in Glossary'
              }
            }
          })
        },
      })
    })
  },
  searchLoadMore() {
    const $search_loadmore = $('.search-page__loadmore'),
      $search_loadmore_button = $('.search-page__loadmore-button'),
      $search_articles = $('.search-page__articles')

    $search_loadmore_button.on('click', function () {
      const data = {
        action: 'loadmore_search',
        query: flow.posts, //eslint-disable-line
        page: flow.current_page, //eslint-disable-line
      }

      $.ajax({
        url: flow.ajax_url, //eslint-disable-line
        data: data,
        type: 'POST',
        beforeSend: function () {
          $search_loadmore_button.attr('disabled', true)
        },
        success: function (response) {
          if (response) {
            $search_articles.append(response)
            flow.current_page++ //eslint-disable-line
            if (flow.current_page == flow.max_pages) $search_loadmore.remove() //eslint-disable-line
          } else {
            $search_loadmore.remove()
          }
        },
        complete: function () {
          $search_loadmore_button.attr('disabled', false)
        },
      })
    })
  },
  searchMore() {
    $('.search-page__loadmore-button').on('click', function () {
      var $this = $(this)
      var click = $this.attr('data-click')
      var ppp = 8
      var new_click = parseInt(click) + 1
      $('.search-page__articles .article-item').each(function (i) {
        if (i >= new_click * ppp && i < new_click * ppp + ppp) {
          $(this).removeClass('hide')
        }
      })
      $this.attr('data-click', new_click)
      var count = $('.search-page__articles .article-item').length
      if ((new_click + 1) * ppp >= count) {
        $this.hide()
      }
    })
  },
  textParallax() {
    $(window).on('load', () => {
      const parallaxText = $('.parallax-text')
      parallaxText.each(function () {
        $(this).attr('data-scroll', 0)
      })
    })
  },
  shareLink() {
    $('.share__link').click(function (e) {
      e.preventDefault()
      var wpWidth = $(window).width(),
        wpHeight = $(window).height()
      window.open(
        $(this).attr('href'),
        'Share',
        'top=' +
          (wpHeight - 400) / 2 +
          ',left=' +
          (wpWidth - 600) / 2 +
          ',width=600,height=400'
      )
    })
  },
  anchorScroll() {
    $(window).on('load', () => {
      if (window.location.hash.length > 0) {
        let scrollTo = 0
        const offset = $(window.location.hash).offset()
        if ($(window).scrollTop() > 0) {
          scrollTo = offset.top - 100
        } else {
          scrollTo = offset.top - 200
        }
        $('body, html').animate({ scrollTop: scrollTo }, 1000)
      }
    })
  },
  hotspotMobile() {
    if ($(window).width() < 1024) {
      let clicks = 0
      $(document)
        .find('.hotspot')
        .on('click', function (e) {
          if (clicks == 0) {
            e.preventDefault()
          } else {
            $(this).unbind('click')
          }
          ++clicks
        })
    }
  },
}
